import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedDropDownRHFWithLabel,
	LabelPosition,
	RHookFormDatePicker,
} from "@websential/cosmic-v20";
import React, { useEffect, useState } from "react";

import { Grid } from "@mui/material";

interface IROEListHeader {
	employeeDDLList?: { label: string; value: any }[];
	onEmployeeStatusSelectionChangeHandler: (params: any) => void;
	onEmployeeSelectionChangeHandler: (params: any) => void;
	selectedItem: number | string;
	setStateRunGetListAPICall:(value:boolean) => void
}

export const ROEListHeader: React.FC<
	IROEListHeader
> = ({ employeeDDLList, onEmployeeStatusSelectionChangeHandler, selectedItem, setStateRunGetListAPICall, onEmployeeSelectionChangeHandler}) => {

	return (
		<>
			<Grid
				container
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{
					background: "#fff",
					border: "1px solid #e5e7eb",
					borderBottom: 0,
					borderRadius: "2px 2px 0 0",
					padding: "31px 20px 1rem 20px",
					marginBottom: "0px!important",
				}} columnSpacing={2}>
				<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {
						},
					}}>
					<EnhancedDropDownRHFWithLabel
						selectName={"employeeDDL"}
						items={employeeDDLList ?? []}
						selectedItem={"all"}
						label={"Employee"}
						testId={"employee-ddl"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						//   onSelectionChangeHandler={onEmployeeSelectionChangeHandler}
					/>
					
					<EnhancedButtonPrimeReact
						label="Apply Filter"
						raised
						type="submit"
						severity={EnhancedButtonPrimeReactSeverity.Secondary}
						// onClickHandler={() => setStateRunGetListAPICall(true)}
					/>
				</Grid>
				<Grid
					size={{ xs: 12, sm: 12, md:0.5 , lg: 0.5 ,xl:0.5 }}>

				</Grid>

					<Grid
					size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}
					sx={{
						color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem",
						"& .MuiGrid-root": {
						},
					}}>
				<EnhancedDropDownRHFWithLabel
						selectName={"status"}
						items={[
							{
								label: "All",
								value: "all",
							},
							{
								label: "Due",
								value: "due",
							},
							{
								label: "Ready",
								value: "ready",
							},
							{
								label: "Issued",
								value: "issued",
							},
							{
								label: "Generated",
								value: "generated",
							},
							{
								label: "Rejected",
								value: "rejected",
							},
						]}
						label={"Status"}
						testId={"status"}
						selectedItem={"all"}
						onSelectionChangeHandler={() => setStateRunGetListAPICall(false)}
						// onSelectionChangeHandler={onEmployeeStatusSelectionChangeHandler}
					/>
				</Grid>
			</Grid>
		</>
	);
};
